import React from 'react';
import _ from 'lodash';
import t from '../../i18n/I18n';
import './../S3Upload.css';
import TreeAssetView from '../../tabs/views/TreeAssetView';
import Portal from '../../common/Portal';
import Button from '../../common/Button';
import Store from '../../store/Store';
import { BREADCRUMB_ASSETS } from '../../store/Constants';
import { DUPLICATE_RENAME, DUPLICATE_SKIP, DUPLICATE_REPLACE, DUPLICATE_ABORT } from '../../util/Constants';
import { RepoItem } from '../../autogenerated/ZoomBridge';
import { RadioGroup2 } from '../../common/form/RadioGroup';
import { ThemeSetup } from '../../themes/ThemeSetup';

const debug = require('debug')('wc:assets:ZoomConfigForm');

type Props = {
  onChange: function
};

type State = {
  sameNameFileOp: string,
  zoomDist: string,
  isOpenFolderSelector: boolean
};
export default class ZoomConfigForm extends React.Component<Props, State> {
  state = { sameNameFileOp: DUPLICATE_SKIP, zoomDist: '', isOpenFolderSelector: false };
  pwd: number;
  componentDidMount() {
    const { zoomDist, sameNameFileOp } = this.props;
    if (zoomDist != '' && sameNameFileOp != '') {
      this.setState({ zoomDist, sameNameFileOp });
    } else {
      const currentPWDS: Array<RepoItem> = Store.get(BREADCRUMB_ASSETS) || [];

      if (currentPWDS.length) {
        let zoomDist: string = _.last(currentPWDS).getRemotePath();
        if (zoomDist === null) {
          const secondLast: number = currentPWDS.length - 2 >= 0 ? currentPWDS.length - 2 : 0;
          zoomDist = currentPWDS[secondLast].getRemotePath() + '/' + currentPWDS[currentPWDS.length - 1].getName();
        }
        zoomDist = zoomDist == '/' ? '/defproj' : zoomDist;
        this.setState({ zoomDist });
        this.props.onChange({ zoomDist });
      } else {
        this.setState({ zoomDist: '/defproj' });
        this.props.onChange({ zoomDist: '/defproj' });
      }
    }
  }
  onChangeFileOp = (OP) => {
    this.setState({ sameNameFileOp: OP }, () => {
      this.props.onChange({ sameNameFileOp: OP });
    });
  };
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onselectedPath = (location: string) => {
    this.pwd = location;
  };
  onCloseClick = () => {
    this.setState({ isOpenFolderSelector: false });
  };
  onClickSelect = () => {
    this.pwd = this.pwd == '/' ? '/defproj' : this.pwd;
    this.setState({ zoomDist: this.pwd, isOpenFolderSelector: false });
    this.props.onChange({ zoomDist: this.pwd });
  };
  onFocus = () => {
    const isOpenFolderSelector: boolean = this.state.isOpenFolderSelector;
    this.setState({ isOpenFolderSelector: !isOpenFolderSelector });
  };

  getStyle = () => {
    const el = document.getElementById('zoomDestinationSelecter');
    if (el) {
      const clientRect = el.getBoundingClientRect();
      let top = clientRect.top + 39;
      return { left: clientRect.left + document.body.scrollLeft - 42, top: top, width: clientRect.width };
    }
    return {};
  };

  renderSameFileOptions = () => {
    const option = this.state.sameNameFileOp;
    const radioProps = {
      value: option,
      title: t('FILE_OPERATION_TITLE'),
      name: 'same_file_options',
      onChange: (value) => this.onChangeFileOp(value),
      options: [
        { value: DUPLICATE_SKIP, label: t('SKIPPED') },
        { value: DUPLICATE_REPLACE, label: t('NEW_VERSION') },
        { value: DUPLICATE_ABORT, label: t('ABORTED') }
      ]
    };
    return <RadioGroup2 {...radioProps} />;
  };

  render() {
    const sameNameFileOp: string = this.state.sameNameFileOp;
    const zoomDist: string = this.state.zoomDist;
    const isOpenFolderSelector: boolean = this.state.isOpenFolderSelector;
    const zoomSelecterStyle = this.getStyle();
    return (
      <div name="ZoomConfigForm">
        <div className="zoom-Destination">{t('ZOOM_DESTINATION')}</div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <label>{t('FILE_INGESTED_TITLE')}</label>
              <div className="input-group mb-3 zoom-dist-selecter-input" onClick={this.onFocus}>
                <div className="input-group-prepend">
                  <span className="input-group-text form-icon-holder">
                    <img src={ThemeSetup.getImageURL('folder.svg')} />
                  </span>
                </div>
                <input
                  id="zoomDestinationSelecter"
                  type="text"
                  name="zoomDist"
                  title={zoomDist}
                  value={zoomDist}
                  onChange={this.onChange}
                  className="form-control"
                  onBlur={this.onBlur}
                  autoComplete={'false'}
                  readOnly={true}
                />
              </div>
              {isOpenFolderSelector ? (
                <FolderSelecter
                  onCloseClick={this.onCloseClick}
                  onselectedPath={this.onselectedPath}
                  onClickSelect={this.onClickSelect}
                  style={zoomSelecterStyle}
                  currentExpends={[0]}
                />
              ) : null}
            </div>
          </div>
          <div className="col-12">{this.renderSameFileOptions()}</div>
        </div>
      </div>
    );
  }
}

type FolderSelecterProps = {
  onselectedPath: () => void,
  onClickSelect: () => void,
  onCloseClick: () => void,
  currentExpends: Number[],
  isIndependentTreeIns: Boolean,
  style: any
};

export const FolderSelecter = function(props: FolderSelecterProps) {
  return (
    <Portal defaultOpen={true} closeOnEsc={true} onClose={props.onCloseClick} closeOnOutsideClick={true}>
      <div style={props.style} className="S3-folder-selecter">
        <div className="tree-list-view-container">
          <div className="tree-view-modal">
            <TreeAssetView
              onselectedPath={props.onselectedPath}
              currentExpends={props.currentExpends}
              isIndependentTreeIns={true}
            />
          </div>
        </div>
        <footer>
          <div className="folder-selecter-footer">
            <Button text={t('CANCEL')} type="CANCEL" className="pull-right" onClick={props.onCloseClick} />
            <Button text={t('SELECT')} type="PRIMARY" className="pull-right" onClick={props.onClickSelect} />
          </div>
        </footer>
      </div>
    </Portal>
  );
};

export const FolderSelecterSip = function(props: FolderSelecterProps) {
  return (
    <div style={props.style} className="S3-folder-selecter">
      <div className="tree-list-view-container">
        <div className="tree-view-modal">
          <TreeAssetView
            onselectedPath={props.onselectedPath}
            currentExpends={props.currentExpends}
            isIndependentTreeIns={true}
          />
        </div>
      </div>
      <footer>
        <div className="folder-selecter-footer">
          <Button text={t('CANCEL')} type="CANCEL" className="pull-right" onClick={props.onCloseClick} />
          <Button text={t('SELECT')} type="PRIMARY" className="pull-right" onClick={props.onClickSelect} />
        </div>
      </footer>
    </div>
  );
};
